<template>
  <section class="">
    <div class="table">
      <div class="tr">
        <span>Position / Duties</span>
        <span v-copy="getAllOptionName21('duties', quoteForm.duty_id)">{{ getAllOptionName21('duties', quoteForm.duty_id) }}</span>
      </div>

      <div class="tr">
        <span>Employment Nature</span>
        <span v-copy="getAllOptionName21('nature', quoteForm.nature)">{{ getAllOptionName21('nature', quoteForm.nature) }}</span>
      </div>
      <div class="tr">
        <span>Nationality</span>
        <span v-copy="getAllOptionName21('nationality', quoteForm.nationality_id)">{{ getAllOptionName21('nationality', quoteForm.nationality_id) }}</span>
      </div>
      <div class="tr">
        <span>Age</span>
        <span v-copy="getAllOptionName21('domestic_age', quoteForm.domestic_age)">{{ getAllOptionName21('domestic_age', quoteForm.domestic_age) }}</span>
      </div>
      <div class="tr">
        <span>Monthly Salary</span>
        <span v-copy="amount">{{ quoteForm.monthly_salary |formatMoney(2, true) }}</span>
      </div>


      <!-- <div class="tr">
        <span>Date of Birth</span>
        <span>{{ quoteForm.domestic_dob }}</span>
      </div> -->
      <div
        v-if="quoteForm.period_of_cvr"
        class="tr">
        <span>Period of Insurance</span>
        <span v-copy="getAllOptionName21('period', quoteForm.period_of_cvr)">{{ getAllOptionName21('period', quoteForm.period_of_cvr) }}</span>
      </div>
      <div
        class="tr">
        <span>Coverage</span>
        <span v-copy="quick_quote_detail.coverage_language">{{ quick_quote_detail.coverage_language }}</span>
      </div>
      <div class="tr">
        <span>
          <!--          <p-->
          <!--            v-for="(item,index) in underwriting"-->
          <!--            :key="index">-->
          <!--            {{item.name}}-->
          <!--          </p>-->
          <p>Confirm All Insurance Underwriting Questions?</p>
        </span>
        <span v-copy="getOptionName('answerList', quick_quote_detail.underwriting_confirm)">{{ getOptionName('answerList', quick_quote_detail.underwriting_confirm) }}</span>
      </div>
      <div
        v-if="benefits.length>0"
        class="tr">
        <span>Insured Items</span>
        <span>
          <span
            v-for="(item,index) in benefits"
            :key="'b'+index"
            v-copy="item">
            {{item}}<br>
          </span>
        </span>
      </div>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
import OMath from '@/utils/math'
export default {
  name: 'HousemaidQuickQuoteInfo',
  mixins: [MixinOptions, MixinFormat],
  props: {
    quoteForm: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {

    }
  },
  computed: {
    amount(){
      let {monthly_salary} = this.quoteForm||{}
      return  OMath.formatMoney(monthly_salary, 2,true)
    },
    localAllOptions() {
      return this.allOptions21
    },
    isDoula() {
      const { duty_id } = this.quoteForm
      const data = this.getOptionData('', duty_id, this.localAllOptions.duties)
      const { doula } = data || {}
      return doula === 1
    },
    salaryOptions() {
      const { salary } = this.localAllOptions
      const { doula = [], others = [] } = salary || {}
      if(this.isDoula) {
        return doula
      }
      return others
    },
    underwriting(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail.underwriting||[]
    },
    quick_quote_detail(){
      let {quick_quote_detail} = this.quoteForm||{}
      return quick_quote_detail||{}
    },
    benefits(){
      let {class_id,benefits=[]} = this.quoteForm||{}
      const benefitsList = benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName21('benefits', item)
        )
        return result
      }, [])
      return benefitsList
    }
  }
}
</script>
<style lang="scss" scoped>
.quick-quote-info {
  //display: flex;
  //justify-content: space-between;
  .table {
    //width: calc(50% - 10px);
    width: 100%;
  }
}
</style>
